"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createStore } from "zustand/vanilla";
import configStore from "./configStore";
import { countGeoDataSource } from "../api";
import { subscribeWithSelector } from "zustand/middleware";
import _ from "lodash";
const store = createStore(
  subscribeWithSelector((set, get) => ({
    /**
     * Counter for the active filters. Will count how many
     * results we currently have.
     */
    count: 0,
    /**
     * Counter for the filters modal. Will count how many
     * results we will have.
     */
    nextCount: 0,
    isLoading: false,
    fetchCount(filters) {
      return __async(this, null, function* () {
        const { locale, isIndex } = configStore.getState();
        set(() => ({ isLoading: true }));
        const count = yield countGeoDataSource({
          filters,
          locale,
          isIndex
        });
        set(() => ({ isLoading: false }));
        return count;
      });
    },
    updateCurrentCountForFilters() {
      return __async(this, arguments, function* (filters = []) {
        const count = yield get().fetchCount(filters);
        set(() => ({ count, nextCount: count }));
        return count;
      });
    },
    updateNextCountForFilters() {
      return __async(this, arguments, function* (filters = []) {
        const nextCount = yield get().fetchCount(filters);
        set(() => ({ nextCount }));
        return nextCount;
      });
    }
  }))
);
export default store;
